import { useEffect, useState } from 'react';
import { Warning } from '@public';

import styles from './notificationToast.module.scss';

interface NotificationToastProps {
	position?: string;
	autoDelete?: boolean;
	itemType: string;
	show: boolean;
}

export const NotificationToast = ({
	position = 'bottom-left',
	autoDelete = true,
	itemType,
	show,
}: NotificationToastProps) => {
	const [showToast, setShowToast] = useState<boolean>(show);
	let title = '';
	let description = '';
	let icon;

	switch (itemType) {
		case 'error':
			title = 'Server error';
			description = 'We have not been able to connect to myID.';
			icon = <Warning customStyles={styles['notification-image-error']} />;
			break;
		case 'device-update-error':
			title = 'Update failed';
			description =
				'Failed to change name. There is an issue with the device name change, please try again later.';
			icon = <Warning customStyles={styles['notification-image-error']} />;
			break;
	}

	useEffect(() => {
		const interval = setInterval(() => {
			if (autoDelete) {
				setShowToast(false);
			}
		}, 6000);

		return () => {
			clearInterval(interval);
		};
	}, [autoDelete]);

	return (
		<div
			className={[styles['notification-container'], position && styles[`${position}`]].join(' ')}
		>
			{showToast && (
				<div
					className={[
						styles.notification,
						styles.toast,
						styles[`${itemType}-container`],
						position && styles[`${position}`],
					].join(' ')}
				>
					<button aria-label="close" onClick={() => setShowToast(false)}>
						X
					</button>
					<div className={styles['notification-image']}>{icon}</div>
					<div>
						<p className={styles['notification-title']}>{title}</p>
						<p className={styles['notification-message']}>{description}</p>
					</div>
				</div>
			)}
		</div>
	);
};
